import { templateService } from '../services/templateService';
import type { QuestionnaireField } from '../types/questionnaires';

/**
 * Creates the Scroll-i-telling template with 5 fields (Quick mode)
 * This preserves the existing Scroll-i-telling functionality as a template
 * 
 * @param userId - User ID creating the template (admin)
 * @param userName - User name creating the template
 * @returns Template ID
 */
export async function createScrollitellingTemplate(userId: string, userName: string): Promise<string> {
  // Define Scroll-i-telling fields based on existing Quick mode
  const fields: QuestionnaireField[] = [
    {
      id: 'projektTitel',
      label: 'Projekttitel',
      type: 'text',
      placeholder: 'Name des Projekts',
      required: true,
      order: 0
    },
    {
      id: 'warumWichtig',
      label: 'Warum ist es ein Meilenstein?',
      type: 'textarea',
      placeholder: 'Beschreiben Sie die Bedeutung...',
      required: true,
      order: 1
    },
    {
      id: 'wowMoment',
      label: 'Was war der Wow-Moment?',
      type: 'textarea',
      placeholder: 'Der besondere Moment...',
      required: true,
      order: 2
    },
    {
      id: 'gefuehl',
      label: 'Was soll der Besucher fühlen oder verstehen?',
      type: 'textarea',
      placeholder: 'Emotionale Wirkung...',
      required: true,
      order: 3
    },
    {
      id: 'materialLink',
      label: 'Link zu Material',
      type: 'text',
      placeholder: 'https://...',
      required: true,
      order: 4
    }
  ];

  const templateId = await templateService.createTemplate({
    name: 'Scroll-i-telling',
    description: 'Schnellerfassung für B2B-Projekt-Showcase (5 Felder)',
    fields,
    createdBy: userId,
    createdByName: userName,
    isSystem: true
  });

  console.log('✅ Scroll-i-telling template created:', templateId);
  return templateId;
}

